/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_minecraft_mode_legacy_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keeps your historical offline player UUID and inventory/data, while injecting your official Mojang skin and cape.`)
};

const zh_hans1_settings_minecraft_mode_legacy_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保留服务器上的历史离线 UUID 与背包/进度数据，同时注入正版签名皮肤与披风。`)
};

const zh_hant1_settings_minecraft_mode_legacy_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保留伺服器上的歷史離線 UUID 與背包/進度資料，同時注入正版簽名皮膚與披風。`)
};

const fr_settings_minecraft_mode_legacy_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conserve votre UUID et inventaire hors ligne historiques tout en appliquant votre skin et cape officiels.`)
};

const de_settings_minecraft_mode_legacy_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Behält Ihre historische Offline-UUID und Ihr Inventar bei und lädt gleichzeitig Ihren offiziellen Skin.`)
};

const ja_settings_minecraft_mode_legacy_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`既存のオフラインUUIDとインベントリ/進行状況を維持しながら、公式Mojangスキンとマントを適用します。`)
};

const ko_settings_minecraft_mode_legacy_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기존 오프라인 UUID와 인벤토리/진행 상황을 유지하면서 공식 Mojang 스킨과 망토를 적용합니다.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_minecraft_mode_legacy_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_minecraft_mode_legacy_desc(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_minecraft_mode_legacy_desc", locale)
	if (locale === "en") return en_settings_minecraft_mode_legacy_desc(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_minecraft_mode_legacy_desc(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_minecraft_mode_legacy_desc(inputs)
	if (locale === "fr") return fr_settings_minecraft_mode_legacy_desc(inputs)
	if (locale === "de") return de_settings_minecraft_mode_legacy_desc(inputs)
	if (locale === "ja") return ja_settings_minecraft_mode_legacy_desc(inputs)
	return ko_settings_minecraft_mode_legacy_desc(inputs)
};